import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, Dropdown, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';

export default function Header() {
  const [user, setUser] = useState(null); // null = not loaded or not logged in
  const [expanded, setExpanded] = useState(false); // Track navbar expansion state
  const [btcPrice, setBtcPrice] = useState(null); // BTC price in USD
  const location = useLocation(); // Track route changes

  const fetchUser = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null); // not logged in
      return;
    }

    try {
      const res = await axios.get('https://swiftexprofit.com/profile', {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data && res.data.user) {
        setUser(res.data.user);
      }
    } catch (err) {
      console.error('Failed to fetch user info:', err);
      setUser(null); // token invalid or request failed
    }
  };

  const fetchBTCPrice = async () => {
    try {
      const res = await axios.get('https://swiftexprofit.com/price/btc');
      if (res.data && res.data.btc_usd) {
        setBtcPrice(res.data.btc_usd);
      }
    } catch (err) {
      console.error('Failed to fetch BTC price:', err);
      setBtcPrice(null);
    }
  };

  useEffect(() => {
    document.body.classList.add('dark');
    fetchUser();
    fetchBTCPrice();

    // Listen to localStorage changes (for login/logout from other tabs)
    const handleStorageChange = () => fetchUser();
    window.addEventListener('storage', handleStorageChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  // Close navbar when route changes (mobile)
  useEffect(() => {
    setExpanded(false);
  }, [location]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    setExpanded(false); // Close navbar
    window.location.href = '/';
  };

  useEffect(() => {
    const interval = setInterval(() => {
      fetchUser();
      fetchBTCPrice(); // Also refresh BTC price
    }, 500); // check every 0.5s
    return () => clearInterval(interval);
  }, []);

  // Handle navbar collapse/expand
  const handleToggle = () => setExpanded(!expanded);
  const closeNavbar = () => setExpanded(false);

  // Calculate USD balance
  const getBalanceUSD = () => {
    if (!user || !user.balance || !btcPrice) return null;
    return (parseFloat(user.balance) * btcPrice).toFixed(2);
  };

  return (
    <header className="light-bb header">
      <Navbar expand="lg" expanded={expanded} onToggle={handleToggle}>
        <Link className="navbar-brand" to="/" onClick={closeNavbar}>
          <img src={require("../assets/img/swiftex1.png")} alt="logo" />
        </Link>
        <Navbar.Toggle aria-controls="basic-navbar-nav">
          <span className="custom-toggler-icon">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="navbar-nav mr-auto">
            <Link to="/" className="nav-link" onClick={closeNavbar}>Home</Link>
            <Link to="/exchange" className="nav-link" onClick={closeNavbar}>Exchange</Link>
            <Link to="/markets" className="nav-link" onClick={closeNavbar}>Markets</Link>
            {user ? (
                <>
                  <Link to="/wallet" className="nav-link" onClick={closeNavbar}>Wallet</Link>
                </>
              ) : (
                <Link to="/login" className="nav-link" onClick={closeNavbar}>Login</Link>
              )}
            <NavDropdown title="Dashboard" className='navDropDown' onClick={(e) => e.stopPropagation()}>
              {user ? (
                <>
                  <Link to="/profile" className="dropdown-item" onClick={closeNavbar}>Profile</Link>
                  <Link to="/settings" className="dropdown-item" onClick={closeNavbar}>Settings</Link>
                </>
              ) : (
                <Link to="/login" className="dropdown-item" onClick={closeNavbar}>Login</Link>
              )}
            </NavDropdown>
          </Nav>
          <Nav className="navbar-nav ml-auto">
            <Dropdown className="header-img-icon">
              <Dropdown.Toggle variant="default">
                <img src="img/avatar.svg" alt="avatar" />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {user ? (
                  <>
                    <div className="dropdown-header d-flex flex-column align-items-center">
                      <div className="figure mb-3">
                        <img src="img/avatar.svg" alt="" />
                      </div>
                      <div className="info text-center">
                        <p className="name font-weight-bold mb-0">{user.username}</p>
                        <p className="email text-muted mb-1">{user.email}</p>
                        {getBalanceUSD() ? (
                          <p className="balance mb-3" style={{ 
                            fontSize: '16px', 
                            fontWeight: '600', 
                            color: '#16a34a',
                            fontFamily: 'monospace'
                          }}>
                            ${Number(getBalanceUSD()).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                        ) : (
                          <p className="balance mb-3" style={{ 
                            fontSize: '14px', 
                            color: '#999'
                          }}>
                            Loading balance...
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="dropdown-body">
                      <ul className="profile-nav">
                        <li className="nav-item">
                          <Link to="/profile" className="nav-link" onClick={closeNavbar}>
                            <i className="icon ion-md-person"></i>
                            <span>Profile</span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/wallet" className="nav-link" onClick={closeNavbar}>
                            <i className="icon ion-md-wallet"></i>
                            <span>My Wallet</span>
                          </Link>
                        </li>
                        <li className="nav-item">
                          <Link to="/settings" className="nav-link" onClick={closeNavbar}>
                            <i className="icon ion-md-settings"></i>
                            <span>Settings</span>
                          </Link>
                        </li>
                        <li className="nav-item" style={{marginLeft: "12%"}}>
                          <button
                            onClick={handleLogout}
                            className="nav-link red"
                            style={{ background: 'none', border: 'none', padding: 0 }}
                          >
                            <i className="icon ion-md-power"></i>
                            <span>Log Out</span>
                          </button>
                        </li>
                      </ul>
                    </div>
                  </>
                ) : (
                  <div className="dropdown-body text-center">
                    <Link to="/login" className="btn btn-primary" onClick={closeNavbar}>
                      Login
                    </Link>
                  </div>
                )}
              </Dropdown.Menu>
            </Dropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
}